<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>机构分销</a-breadcrumb-item>
    <a-breadcrumb-item>机构管理</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">昵称：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="nameModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col> -->
      <!-- 手机号 -->
      <!-- <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">手机号：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="phoneModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col> -->
      <!-- UID -->
      <!-- <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">UID：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="uidModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col> -->
      <!-- 团长ID -->
      <!-- <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">团长ID：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="leaderidModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col> -->
      <!-- 账号状态 -->
      <!-- <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">账号状态：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="stateModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="1">正常</a-select-option>
              <a-select-option :value="2">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col> -->
      <!-- 操作 -->
      <!-- <a-col :span="4">
        <a-row>
          <a-col :span="5" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col> -->
      <a-col :span="24" style="text-align: right; white-space: nowrap;">
        <a-button type="primary" @click="addDouyin"><PlusOutlined />添加机构</a-button>
      </a-col>
    </a-row>
  </div>
  <a-table
    :data-source="dataSource"
    :columns="columns"
    :pagination="pagination"
    :row-key="record => record.id"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 注册时间 -->
      <template v-if="column.key === 'date'">
        <a-tooltip>
          <template #title>{{ record[column.key] }}</template>
          {{ record[column.key] || '-' }}
        </a-tooltip>
      </template>
      <!-- 上次登录 -->
      <template v-else-if="column.key === 'last_login_time'">
        <a-tooltip>
          <template #title>{{ record[column.key] }}</template>
          {{ record[column.key] ? record[column.key].substring(0,10) : '-' }}
        </a-tooltip>
      </template>
      <!-- 账号状态 -->
      <template v-else-if="column.key === 'status'">
        <a-tooltip>
          <template #title v-if="record[column.key] == 2">{{ record.create_username }}与{{ record.updated_time }}禁用</template>
          {{ record[column.key] == 1 ? '正常' : '禁用' }}
        </a-tooltip>
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a class="operation-item" @click="touchBinding(record)">团长管理</a>
        <a class="operation-item" @click="touchLink(record)">数据链接</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" @success="getList" />
  <!-- 团长管理 -->
  <Client ref="RefClient" @success="getList" />
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { darenEnable } from '@/api/request'
import { agencyList } from '@/api/agency'
import Add from './components-mgmt/Add.vue'
import Client from './components-copyright-holder/Client.vue'
import Pub from '@/utils/public'

// 打款信息
let RefBinding = ref(null)
// 昵称
let name = ref(undefined)
let nameModel = ref(undefined)
// 手机号
let phone = ref(undefined) 
let phoneModel = ref(undefined) 
// UID
let uid = ref(undefined) 
let uidModel = ref(undefined)
// 团长ID
// let leaderid = ref(undefined) 
// let leaderidModel = ref(undefined) 
// 账号状态
let state = ref(undefined) 
// 团长
let RefClient = ref(null)
// 新增
let RefAdd = ref(null)
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: '机构ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '机构名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '关联团长数',
    dataIndex: 'leader_count',
    key: 'leader_count',
  },
  {
    title: '关联达人数',
    dataIndex: 'daren_count',
    key: 'daren_count',
  },
  {
    title: '入库日期',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  // 初始化选择项列表
  getSelectList()
  // 获取列表
  getList()
})

// 初始化选择项列表
function getSelectList () {

}

// 团长管理弹窗
function touchBinding(record) {
  RefClient.value.showDrawer(record)
}

// 数据链接
function touchLink(record) {
  Pub.COPY(`【${record.name}】机构链接：${Pub.DOMAIN_NAME()}/summary-data?type=3&id=${record.provider_number}`)
}

// 查询
function touchSearch () {
  // 调整参数
  name.value = nameModel.value
  phone.value = phoneModel.value
  uid.value = uidModel.value
  // leaderid.value = leaderidModel.value
  state.value = stateModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  name.value = undefined
  nameModel.value = undefined
  phone.value = undefined
  phoneModel.value = undefined
  uid.value = undefined
  uidModel.value = undefined
  // leaderid.value = undefined
  // leaderidModel.value = undefined
  state.value = undefined
  stateModel.value = undefined
  // 初始化获取
  touchSearch()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  console.log('[AgencyMgmt] agencyList params:', params)
  agencyList(params).then(res => {
    isLoading.value = false
    console.log('[AgencyMgmt] agencyList response:', res)
    const { code, msg, data } = res
    if (code === 0) {
      const list = data.data
      dataSource.value = list
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 禁用/启用
function touchEnable (record, state) {
  Modal.confirm({
    title: `确定${state ? '启用' : '禁用'}吗?`,
    onOk() {
      darenEnable({uid: record.uid, status: state}).then(res => {
        const { code } = res
        if (code === 0) {
          message.success('操作成功')
          getList()
        } else {
          message.error(res.message ?? '操作失败')
        }
      })
    },
  });
}

// 添加抖音号
function addDouyin () {
  RefAdd.value.showDrawer()
}

// 编辑机构
function touchEdit (record) {
  RefAdd.value.showDrawer(record)
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}
</style>